import { useState, useEffect } from 'react';

const SCRIPT_ID = 'naver-maps-script-promise';
const NCP_KEY_ID = "8ahc4qz8z8"; // <<< 반드시 본인의 Client ID로 교체해주세요!
const CALLBACK_NAME = 'initNaverMap';

// 스크립트 로딩 상태를 전역적으로 관리하기 위한 Promise
let mapScriptPromise = null;

const useNaverMaps = () => {
  const [isReady, setIsReady] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // window.naver 객체가 이미 존재하면, 스크립트가 로드된 것이므로 즉시 완료 처리
    if (window.naver && window.naver.maps) {
      setIsReady(true);
      return;
    }

    // 다른 컴포넌트에서 이미 스크립트 로딩을 시작했다면, 그 결과를 기다림
    if (mapScriptPromise) {
      mapScriptPromise
        .then(() => setIsReady(true))
        .catch((err) => setError(err));
      return;
    }

    // 스크립트 로딩을 위한 새로운 Promise 생성
    mapScriptPromise = new Promise((resolve, reject) => {
      // Client ID가 설정되지 않았으면 오류 처리
      if (!NCP_KEY_ID || NCP_KEY_ID === "YOUR_NCP_CLIENT_ID") {
        return reject(new Error("Naver Cloud Platform Client ID가 설정되지 않았습니다."));
      }
      
      const existingScript = document.getElementById(SCRIPT_ID);
      if (existingScript) {
        // 스크립트 태그는 있지만 아직 로드되지 않은 경우를 대비
        existingScript.addEventListener('load', () => resolve());
        existingScript.addEventListener('error', (e) => reject(e));
        return;
      }
      
      // 전역 콜백 함수 정의 (스크립트 로드 완료 시 Naver 서버가 호출)
      window[CALLBACK_NAME] = () => {
        console.log("Naver Maps API and submodules are ready.");
        resolve(); // Promise를 성공 상태로 변경
        delete window[CALLBACK_NAME]; // 성공 후 전역 함수 정리
      };

      // 스크립트 태그 생성
      const script = document.createElement('script');
      script.id = SCRIPT_ID;
      script.src = `https://oapi.map.naver.com/openapi/v3/maps.js?ncpKeyId=${NCP_KEY_ID}&submodules=geocoder&callback=${CALLBACK_NAME}`;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);

      script.onerror = (e) => {
        console.error("Naver Maps 스크립트 로드 실패.", e);
        reject(new Error("지도 스크립트를 불러오는 데 실패했습니다."));
        delete window[CALLBACK_NAME]; // 실패 시에도 전역 함수 정리
        document.head.removeChild(script);
        mapScriptPromise = null; // 실패 시 다시 시도할 수 있도록 Promise 초기화
      };
    });

    // 생성된 Promise의 결과를 현재 컴포넌트의 상태에 반영
    mapScriptPromise
      .then(() => {
        setIsReady(true);
      })
      .catch((err) => {
        setError(err);
      });

  }, []); // 이 훅은 컴포넌트가 마운트될 때 한 번만 실행됩니다.

  return { isReady, error };
};

export default useNaverMaps;
